import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Tabs,
    Tab,
    Box,
    TextField,
    Select,
    MenuItem,
    FormControl,
    FormControlLabel,
    InputLabel,
    Typography,
    Grid,
    Chip,
    Radio,
    RadioGroup
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Autocomplete from "@material-ui/lab/Autocomplete";


import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
    tabPanel: {
        padding: theme.spacing(2),
    },
    uploadButton: {
        margin: theme.spacing(2, 0),
    },
    variableChip: {
        margin: theme.spacing(0.5),
    },
    dialogPaper: {
        border: "1px solid #E8EBF1",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "12px",
    },
}));

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index}>
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

const CampaignModal = ({ open, onClose, campaignId }) => {
    const classes = useStyles();
    const [activeTab, setActiveTab] = useState(0);
    const [whatsapps, setWhatsapps] = useState([]);
    const [csvFile, setCsvFile] = useState(null);
    const [mediaFile, setMediaFile] = useState(null);
    const [buttonImageFile, setButtonImageFile] = useState(null);
    const [listImageFile, setListImageFile] = useState(null);
    const [carouselImageFiles, setCarouselImageFiles] = useState([]);
    const [campaign, setCampaign] = useState({
        name: "",
        whatsappId: "",
        delayMin: 30,
        delayMax: 300,
        startTime: "08:00",
        endTime: "18:00",
        optOutKeyword: "SAIR",
        optOutMessage: "Você foi removido da lista. Não receberá mais mensagens.",
    });
    const [messages, setMessages] = useState([
        { variationNumber: 1, messageType: "text", content: { text: "" } },
        { variationNumber: 2, messageType: "text", content: { text: "" } },
        { variationNumber: 3, messageType: "text", content: { text: "" } },
    ]);
    const [messageType, setMessageType] = useState("text");
    const [mediaUrl, setMediaUrl] = useState("");

    // Estados para botões
    const [buttonText, setButtonText] = useState("");
    const [buttonFooter, setButtonFooter] = useState("");
    const [buttonImage, setButtonImage] = useState("");
    const [buttonType, setButtonType] = useState("REPLY"); // REPLY, URL, CALL, COPY
    const [buttons, setButtons] = useState(["", "", ""]);

    // Estados para lista
    const [listText, setListText] = useState("");
    const [listButton, setListButton] = useState("Ver opções");
    const [listImage, setListImage] = useState("");
    const [listItems, setListItems] = useState([""]);

    // Estados para carrossel
    const [carouselText, setCarouselText] = useState("");
    const [carouselCards, setCarouselCards] = useState([{ title: "", image: "", imageFile: null, buttons: ["", ""] }]);

    // Estados para Targeting (CSV ou Tags)
    const [targetMode, setTargetMode] = useState("csv"); // csv | tags
    const [tags, setTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);


    useEffect(() => {
        const fetchWhatsapps = async () => {
            try {
                const { data } = await api.get("/whatsapp");
                setWhatsapps(data);
            } catch (err) {
                toastError(err);
            }
        };
        const fetchTags = async () => {
            try {
                const { data } = await api.get("/tags/list");
                setTags(data);
            } catch (err) {
                toastError(err);
            }
        };
        fetchWhatsapps();
        fetchTags();
    }, []);

    useEffect(() => {
        if (campaignId) {
            const fetchCampaign = async () => {
                try {
                    const { data } = await api.get(`/campaigns/${campaignId}`);
                    setCampaign(data);
                    if (data.campaignMessages && data.campaignMessages.length > 0) {
                        const parsedMessages = data.campaignMessages.map(msg => {
                            let content = msg.content;
                            if (typeof content === "string") {
                                try { content = JSON.parse(content); } catch (e) { content = {}; }
                            }
                            return { ...msg, content };
                        });
                        setMessages(parsedMessages);
                        const msgType = parsedMessages[0].messageType;
                        setMessageType(msgType);

                        // Popular campos específicos baseado no tipo
                        const firstMsg = parsedMessages[0];
                        if (msgType === "button" && firstMsg.content) {
                            setButtonText(firstMsg.content.text || "");
                            setButtonFooter(firstMsg.content.footerText || "");
                            setButtonImage(firstMsg.content.imageButton || "");
                            setButtons(firstMsg.content.choices || ["", "", ""]);
                        } else if (msgType === "list" && firstMsg.content) {
                            setListText(firstMsg.content.text || "");
                            setListButton(firstMsg.content.listButton || "Ver opções");
                            setListImage(firstMsg.content.imageList || "");
                            setListItems(firstMsg.content.choices || [""]);
                        } else if (msgType === "carousel" && firstMsg.content) {
                            setCarouselText(firstMsg.content.text || "");
                            // Reconstruir cards a partir de choices
                            if (firstMsg.content.choices && Array.isArray(firstMsg.content.choices)) {
                                const cards = [];
                                let currentCard = null;
                                for (const choice of firstMsg.content.choices) {
                                    if (choice.startsWith('[') && choice.endsWith(']')) {
                                        if (currentCard) cards.push(currentCard);
                                        currentCard = { title: choice.slice(1, -1), image: "", imageFile: null, buttons: [] };
                                    } else if (choice.startsWith('{') && choice.endsWith('}') && currentCard) {
                                        currentCard.image = choice.slice(1, -1);
                                    } else if (currentCard) {
                                        currentCard.buttons.push(choice);
                                    }
                                }
                                if (currentCard) cards.push(currentCard);
                                if (cards.length > 0) setCarouselCards(cards);
                            }
                        } else if (msgType === "image" || msgType === "video" || msgType === "document") {
                            if (firstMsg.content && firstMsg.content.mediaUrl) {
                                setMediaUrl(firstMsg.content.mediaUrl);
                            }
                        }
                    }
                } catch (err) {
                    toastError(err);
                }
            };
            fetchCampaign();
        }
    }, [campaignId]);

    const handleClose = () => {
        setCampaign({
            name: "",
            whatsappId: "",
            delayMin: 30,
            delayMax: 300,
            startTime: "08:00",
            endTime: "18:00",
            optOutKeyword: "SAIR",
            optOutMessage: "Você foi removido da lista. Não receberá mais mensagens.",
        });
        setMessages([
            { variationNumber: 1, messageType: "text", content: { text: "" } },
            { variationNumber: 2, messageType: "text", content: { text: "" } },
            { variationNumber: 3, messageType: "text", content: { text: "" } },
        ]);
        setMessageType("text");
        setMediaUrl("");
        setCsvFile(null);
        setMediaFile(null);
        setActiveTab(0);
        setTargetMode("csv");
        setSelectedTags([]);
        onClose();
    };

    const handleSaveCampaign = async () => {
        try {
            if (!campaign.name || !campaign.whatsappId) {
                toast.error("Nome e conexão WhatsApp são obrigatórios");
                return;
            }

            // Validar se o primeiro campo de mensagem possui texto
            if (["text", "image", "video", "document"].includes(messageType)) {
                if (!messages[0].content || !messages[0].content.text || messages[0].content.text.trim() === "") {
                    toast.error("Por favor, preencha pelo menos a primeira variação da mensagem antes de salvar.");
                    return;
                }
            } else if (messageType === "button" && (!buttonText || buttonText.trim() === "")) {
                toast.error("Por favor, preencha o cabeçalho do botão.");
                return;
            } else if (messageType === "list" && (!listText || listText.trim() === "")) {
                toast.error("Por favor, preencha o texto da lista.");
                return;
            } else if (messageType === "carousel" && (!carouselText || carouselText.trim() === "")) {
                toast.error("Por favor, preencha o texto principal do carrossel.");
                return;
            }

            let savedCampaign;
            if (campaignId) {
                const { data } = await api.put(`/campaigns/${campaignId}`, campaign);
                savedCampaign = data;
            } else {
                const { data } = await api.post("/campaigns", campaign);
                savedCampaign = data;
            }

            // Upload CSV se houver e estiver no modo CSV
            if (targetMode === "csv" && csvFile && savedCampaign.id) {
                const formData = new FormData();
                formData.append("file", csvFile);
                await api.post(`/campaigns/${savedCampaign.id}/upload-csv`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            } else if (targetMode === "tags" && selectedTags.length > 0 && savedCampaign.id) {
                // Adicionar contatos por tags
                await api.post(`/campaigns/${savedCampaign.id}/tags`, {
                    tagIds: selectedTags.map(t => t.id)
                });
            }

            // Upload de mídia se houver
            let uploadedMediaUrl = mediaUrl;
            if (mediaFile && savedCampaign.id) {
                const formData = new FormData();
                formData.append("file", mediaFile);
                const { data } = await api.post(`/campaigns/${savedCampaign.id}/upload-media`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                uploadedMediaUrl = data.url;
            }

            // Upload de imagens para botões/listas/carrossel
            let uploadedButtonImage = buttonImage;
            let uploadedListImage = listImage;

            if (savedCampaign.id) {
                // Upload imagem do botão
                if (messageType === 'button' && buttonImageFile) {
                    const formData = new FormData();
                    formData.append('file', buttonImageFile);
                    const { data } = await api.post(
                        `/campaigns/${savedCampaign.id}/upload-message-media`,
                        formData,
                        { headers: { 'Content-Type': 'multipart/form-data' } }
                    );
                    uploadedButtonImage = data.url;
                }

                // Upload imagem da lista
                if (messageType === 'list' && listImageFile) {
                    const formData = new FormData();
                    formData.append('file', listImageFile);
                    const { data } = await api.post(
                        `/campaigns/${savedCampaign.id}/upload-message-media`,
                        formData,
                        { headers: { 'Content-Type': 'multipart/form-data' } }
                    );
                    uploadedListImage = data.url;
                }

                // Upload imagens do carrossel
                if (messageType === 'carousel') {
                    for (let i = 0; i < carouselCards.length; i++) {
                        if (carouselCards[i].imageFile) {
                            const formData = new FormData();
                            formData.append('file', carouselCards[i].imageFile);
                            const { data } = await api.post(
                                `/campaigns/${savedCampaign.id}/upload-message-media`,
                                formData,
                                { headers: { 'Content-Type': 'multipart/form-data' } }
                            );
                            carouselCards[i].image = data.url;
                        }
                    }
                }
            }

            // Salvar mensagens
            if (savedCampaign.id) {
                const messagesPayload = messages.map(msg => {
                    const content = { ...msg.content };

                    // Adicionar campos específicos por tipo
                    if (messageType === "image" || messageType === "video" || messageType === "document") {
                        content.mediaUrl = uploadedMediaUrl;
                    } else if (messageType === "button") {
                        content.text = buttonText;
                        content.footerText = buttonFooter;
                        content.imageButton = uploadedButtonImage;
                        content.buttonType = buttonType; // REPLY, URL, CALL, COPY
                        content.choices = buttons.filter(b => b.trim());
                    } else if (messageType === "list") {
                        content.text = listText;
                        content.listButton = listButton;
                        content.imageList = uploadedListImage;
                        content.choices = listItems.filter(i => i.trim());
                    } else if (messageType === "carousel") {
                        content.text = carouselText;
                        content.choices = carouselCards.flatMap(card => [
                            `[${card.title}]`,
                            `{${card.image}}`,
                            ...card.buttons.filter(b => b.trim())
                        ]);
                    }

                    return {
                        ...msg,
                        messageType,
                        content
                    };
                });

                await api.post(`/campaigns/${savedCampaign.id}/messages`, {
                    messages: messagesPayload,
                });
            }

            toast.success(i18n.t("campaigns.toasts.saved"));
            handleClose();
        } catch (err) {
            toastError(err);
        }
    };

    const handleFileChange = (e) => {
        setCsvFile(e.target.files[0]);
    };

    const handleMediaFileChange = (e) => {
        setMediaFile(e.target.files[0]);
    };

    const insertVariable = (variable, fieldType = 'text') => {
        const varText = `{{${variable}}}`;

        // Inserir variável no campo apropriado baseado no tipo de mensagem
        if (messageType === 'button') {
            if (fieldType === 'footer') {
                setButtonFooter(buttonFooter + varText);
            } else {
                setButtonText(buttonText + varText);
            }
        } else if (messageType === 'list') {
            setListText(listText + varText);
        } else if (messageType === 'carousel') {
            setCarouselText(carouselText + varText);
        } else {
            // Para text, image, video, document
            const updatedMessages = [...messages];
            const currentText = updatedMessages[0].content.text || "";
            updatedMessages[0] = {
                ...updatedMessages[0],
                content: {
                    ...updatedMessages[0].content,
                    text: currentText + varText
                }
            };
            setMessages(updatedMessages);
        }
    };

    const needsMediaUpload = () => {
        return ["image", "video", "document"].includes(messageType);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                className: classes.dialogPaper
            }}
        >
            <DialogTitle>
                {campaignId
                    ? i18n.t("campaigns.modal.title.edit")
                    : i18n.t("campaigns.modal.title.add")}
            </DialogTitle>
            <DialogContent dividers>
                <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
                    <Tab label={i18n.t("campaigns.modal.tabs.definitions")} />
                    <Tab label={i18n.t("campaigns.modal.tabs.message")} />
                    <Tab label={i18n.t("campaigns.modal.tabs.optOut")} />
                </Tabs>

                {/* Aba 1: Definições */}
                <TabPanel value={activeTab} index={0}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label={i18n.t("campaigns.modal.form.name")}
                                value={campaign.name}
                                onChange={(e) => setCampaign({ ...campaign, name: e.target.value })}
                                variant="outlined"
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" fullWidth required>
                                <InputLabel>{i18n.t("campaigns.modal.form.whatsapp")}</InputLabel>
                                <Select
                                    value={campaign.whatsappId}
                                    onChange={(e) => setCampaign({ ...campaign, whatsappId: e.target.value })}
                                    label={i18n.t("campaigns.modal.form.whatsapp")}
                                >
                                    {whatsapps.map(whatsapp => (
                                        <MenuItem key={whatsapp.id} value={whatsapp.id}>
                                            {whatsapp.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Tipo de Mensagem */}
                        <Grid item xs={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel>{i18n.t("campaigns.modal.form.messageType")}</InputLabel>
                                <Select
                                    value={messageType}
                                    onChange={(e) => {
                                        setMessageType(e.target.value);
                                        const updatedMessages = messages.map(msg => ({
                                            ...msg,
                                            messageType: e.target.value,
                                        }));
                                        setMessages(updatedMessages);
                                    }}
                                    label={i18n.t("campaigns.modal.form.messageType")}
                                >
                                    <MenuItem value="text">{i18n.t("campaigns.modal.messageTypes.text")}</MenuItem>
                                    <MenuItem value="image">{i18n.t("campaigns.modal.messageTypes.image")}</MenuItem>
                                    <MenuItem value="video">{i18n.t("campaigns.modal.messageTypes.video")}</MenuItem>
                                    <MenuItem value="document">{i18n.t("campaigns.modal.messageTypes.document")}</MenuItem>
                                    <MenuItem value="button">{i18n.t("campaigns.modal.messageTypes.button")}</MenuItem>
                                    <MenuItem value="list">{i18n.t("campaigns.modal.messageTypes.list")}</MenuItem>
                                    <MenuItem value="carousel">{i18n.t("campaigns.modal.messageTypes.carousel")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Upload de mídia condicional */}
                        {needsMediaUpload() && (
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<CloudUploadIcon />}
                                    className={classes.uploadButton}
                                >
                                    {mediaFile ? mediaFile.name : (mediaUrl ? mediaUrl.split(/[\\/]/).pop() : i18n.t("campaigns.modal.form.uploadMedia"))}
                                    <input
                                        type="file"
                                        accept={messageType === "image" ? "image/*" : messageType === "video" ? "video/*" : ".pdf"}
                                        hidden
                                        onChange={handleMediaFileChange}
                                    />
                                </Button>
                                <Typography variant="caption" display="block">
                                    {i18n.t("campaigns.modal.form.mediaHelper")}
                                </Typography>
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <Typography variant="subtitle2" gutterBottom>
                                    Modo de Envio
                                </Typography>
                                <RadioGroup
                                    row
                                    value={targetMode}
                                    onChange={(e) => setTargetMode(e.target.value)}
                                >
                                    <FormControlLabel value="csv" control={<Radio />} label="Arquivo CSV" />
                                    <FormControlLabel value="tags" control={<Radio />} label="Tags / Etiquetas" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        {targetMode === "csv" ? (
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<CloudUploadIcon />}
                                    className={classes.uploadButton}
                                >
                                    {csvFile ? csvFile.name : (campaign.csvFile ? campaign.csvFile.split(/[\\/]/).pop() : i18n.t("campaigns.modal.form.uploadCsv"))}
                                    <input type="file" accept=".csv" hidden onChange={handleFileChange} />
                                </Button>
                                <Typography variant="caption" display="block">
                                    {i18n.t("campaigns.modal.form.csvHelper")}
                                </Typography>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Autocomplete
                                    multiple
                                    options={tags}
                                    getOptionLabel={(option) => option.name}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    renderOption={(option) => (
                                        <React.Fragment>
                                            {option.name} <span style={{ color: '#888', fontSize: '0.8em', marginLeft: '5px' }}>({option.contactsCount || 0})</span>
                                        </React.Fragment>
                                    )}
                                    value={selectedTags}
                                    onChange={(e, newValue) => setSelectedTags(newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Selecione as Tags"
                                            placeholder="Tags"
                                        />
                                    )}
                                />
                            </Grid>
                        )}
                        <Grid item xs={6}>
                            <TextField
                                label={i18n.t("campaigns.modal.form.delayMin")}
                                type="number"
                                value={campaign.delayMin}
                                onChange={(e) => setCampaign({ ...campaign, delayMin: parseInt(e.target.value) })}
                                variant="outlined"
                                fullWidth
                                inputProps={{ min: 10 }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label={i18n.t("campaigns.modal.form.delayMax")}
                                type="number"
                                value={campaign.delayMax}
                                onChange={(e) => setCampaign({ ...campaign, delayMax: parseInt(e.target.value) })}
                                variant="outlined"
                                fullWidth
                                inputProps={{ min: 60 }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label={i18n.t("campaigns.modal.form.startTime")}
                                type="time"
                                value={campaign.startTime}
                                onChange={(e) => setCampaign({ ...campaign, startTime: e.target.value })}
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label={i18n.t("campaigns.modal.form.endTime")}
                                type="time"
                                value={campaign.endTime}
                                onChange={(e) => setCampaign({ ...campaign, endTime: e.target.value })}
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                    </Grid>
                </TabPanel>

                {/* Aba 2: Saudações/Mensagens */}
                <TabPanel value={activeTab} index={1}>
                    <Typography variant="body2" gutterBottom>
                        {i18n.t("campaigns.modal.form.variablesHelper")}
                    </Typography>
                    <Box mb={2}>
                        <Chip
                            label="{{nome}}"
                            size="small"
                            className={classes.variableChip}
                            onClick={() => insertVariable("nome", 0)}
                        />
                        <Chip
                            label="{{variavel01}}"
                            size="small"
                            className={classes.variableChip}
                            onClick={() => insertVariable("variavel01", 0)}
                        />
                        <Chip
                            label="{{variavel02}}"
                            size="small"
                            className={classes.variableChip}
                            onClick={() => insertVariable("variavel02", 0)}
                        />
                        <Chip
                            label="{{variavel03}}"
                            size="small"
                            className={classes.variableChip}
                            onClick={() => insertVariable("variavel03", 0)}
                        />
                    </Box>

                    {/* Mensagens de texto (sempre visível) */}
                    {["text", "image", "video", "document"].includes(messageType) && messages.map((msg, index) => (
                        <TextField
                            key={index}
                            label={`${i18n.t("campaigns.modal.form.message")} ${index + 1}`}
                            value={msg.content.text || ""}
                            onChange={(e) => {
                                const updatedMessages = [...messages];
                                updatedMessages[index] = {
                                    ...updatedMessages[index],
                                    content: {
                                        ...updatedMessages[index].content,
                                        text: e.target.value
                                    }
                                };
                                setMessages(updatedMessages);
                            }}
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={6}
                            margin="normal"
                        />
                    ))}

                    {/* Configuração de Botões */}
                    {messageType === "button" && (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Texto do cabeçalho"
                                    value={buttonText}
                                    onChange={(e) => setButtonText(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={2}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Texto do rodapé"
                                    value={buttonFooter}
                                    onChange={(e) => setButtonFooter(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<CloudUploadIcon />}
                                    className={classes.uploadButton}
                                >
                                    {buttonImageFile ? buttonImageFile.name : (buttonImage ? buttonImage.split(/[\\/]/).pop() : "Upload Imagem (Opcional)")}
                                    <input
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        onChange={(e) => setButtonImageFile(e.target.files[0])}
                                    />
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl component="fieldset">
                                    <Typography variant="subtitle2" gutterBottom>
                                        Tipo de Botão (todos devem ser do mesmo tipo)
                                    </Typography>
                                    <RadioGroup
                                        row
                                        value={buttonType}
                                        onChange={(e) => setButtonType(e.target.value)}
                                    >
                                        <FormControlLabel value="REPLY" control={<Radio />} label="Resposta" />
                                        <FormControlLabel value="URL" control={<Radio />} label="URL" />
                                        <FormControlLabel value="CALL" control={<Radio />} label="Ligar" />
                                        <FormControlLabel value="COPY" control={<Radio />} label="Copiar" />
                                    </RadioGroup>
                                    <Typography variant="caption" color="textSecondary">
                                        {buttonType === 'REPLY' && 'Formato: Texto|id (ex: Produto A|prod_a)'}
                                        {buttonType === 'URL' && 'Formato: Texto|https://url (ex: Ver Mais|https://site.com)'}
                                        {buttonType === 'CALL' && 'Formato: Texto|call:+5531999999999'}
                                        {buttonType === 'COPY' && 'Formato: Texto|copy:CUPOM20'}
                                    </Typography>
                                </FormControl>
                            </Grid>
                            {buttons.map((btn, idx) => (
                                <Grid item xs={12} key={idx}>
                                    <TextField
                                        label={`Botão ${idx + 1} (Texto|Ação)`}
                                        value={btn}
                                        onChange={(e) => {
                                            const newButtons = [...buttons];
                                            newButtons[idx] = e.target.value;
                                            setButtons(newButtons);
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Ver Ofertas|https://loja.com"
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    )}

                    {/* Configuração de Lista */}
                    {messageType === "list" && (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Texto da mensagem"
                                    value={listText}
                                    onChange={(e) => setListText(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={2}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Texto do botão"
                                    value={listButton}
                                    onChange={(e) => setListButton(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={<CloudUploadIcon />}
                                    className={classes.uploadButton}
                                >
                                    {listImageFile ? listImageFile.name : (listImage ? listImage.split(/[\\/]/).pop() : "Upload Imagem (Opcional)")}
                                    <input
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        onChange={(e) => setListImageFile(e.target.files[0])}
                                    />
                                </Button>
                            </Grid>
                            {listItems.map((item, idx) => (
                                <Grid item xs={12} key={idx}>
                                    <TextField
                                        label={`Item ${idx + 1}`}
                                        value={item}
                                        onChange={(e) => {
                                            const newItems = [...listItems];
                                            newItems[idx] = e.target.value;
                                            setListItems(newItems);
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        placeholder="[Categoria] ou Texto|ID"
                                    />
                                </Grid>
                            ))}
                            <Grid item xs={12}>
                                <Button onClick={() => setListItems([...listItems, ""])}>
                                    Adicionar Item
                                </Button>
                            </Grid>
                        </Grid>
                    )}

                    {/* Configuração de Carrossel */}
                    {messageType === "carousel" && (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Texto da mensagem"
                                    value={carouselText}
                                    onChange={(e) => setCarouselText(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={3}
                                />
                            </Grid>
                            {carouselCards.map((card, idx) => (
                                <Grid item xs={12} key={idx}>
                                    <Typography variant="subtitle2">Card {idx + 1}</Typography>
                                    <TextField
                                        label="Título"
                                        value={card.title}
                                        onChange={(e) => {
                                            const newCards = [...carouselCards];
                                            newCards[idx].title = e.target.value;
                                            setCarouselCards(newCards);
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        margin="dense"
                                    />
                                    <Button
                                        variant="contained"
                                        component="label"
                                        startIcon={<CloudUploadIcon />}
                                        className={classes.uploadButton}
                                        fullWidth
                                    >
                                        {card.imageFile ? card.imageFile.name : "Upload Imagem (Obrigatório)"}
                                        <input
                                            type="file"
                                            accept="image/*"
                                            hidden
                                            onChange={(e) => {
                                                const newCards = [...carouselCards];
                                                newCards[idx].imageFile = e.target.files[0];
                                                setCarouselCards(newCards);
                                            }}
                                        />
                                    </Button>
                                    {card.buttons.map((btn, btnIdx) => (
                                        <TextField
                                            key={btnIdx}
                                            label={`Botão ${btnIdx + 1}`}
                                            value={btn}
                                            onChange={(e) => {
                                                const newCards = [...carouselCards];
                                                newCards[idx].buttons[btnIdx] = e.target.value;
                                                setCarouselCards(newCards);
                                            }}
                                            variant="outlined"
                                            fullWidth
                                            margin="dense"
                                            placeholder="Texto|Ação"
                                        />
                                    ))}
                                </Grid>
                            ))}
                            <Grid item xs={12}>
                                <Button onClick={() => setCarouselCards([...carouselCards, { title: "", image: "", buttons: ["", ""] }])}>
                                    Adicionar Card
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </TabPanel>

                {/* Aba 3: Opção Sair */}
                <TabPanel value={activeTab} index={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label={i18n.t("campaigns.modal.form.optOutKeyword")}
                                value={campaign.optOutKeyword}
                                onChange={(e) => setCampaign({ ...campaign, optOutKeyword: e.target.value })}
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={i18n.t("campaigns.modal.form.optOutMessage")}
                                value={campaign.optOutMessage}
                                onChange={(e) => setCampaign({ ...campaign, optOutMessage: e.target.value })}
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </Grid>
                    </Grid>
                </TabPanel>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    {i18n.t("campaigns.modal.buttons.cancel")}
                </Button>
                <Button onClick={handleSaveCampaign} color="primary" variant="contained">
                    {i18n.t("campaigns.modal.buttons.save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CampaignModal;
